import { render, staticRenderFns } from "./BlogPostsFeed.vue?vue&type=template&id=a990886c&scoped=true&"
import script from "./BlogPostsFeed.vue?vue&type=script&lang=js&"
export * from "./BlogPostsFeed.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsFeed.vue?vue&type=style&index=0&id=a990886c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a990886c",
  null
  
)

export default component.exports